import styled from 'styled-components';
import { Stack } from '@mui/material';

export const ConfigureDrawerHeader = styled(Stack)<{ isChat?: boolean }>(({ isChat }) => ({
  paddingBottom: isChat ? '4px' : '8px',
  paddingTop: '12px',
  paddingLeft: '12px',
  paddingRight: '12px',
}));

export const ConfigureDrawerContent = styled(Stack)({
  paddingBottom: '16px',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '8px',
  height: '100%',
});
